import { PropTypes } from 'prop-types';
import React, { useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AccionaButton from '../../../../components/AccionaButton';
import AccionaTable from '../../../../components/AccionaTable';
import AccionaTableButton from '../../../../components/AccionaTable/AccionaTableButton';
import ProviderRecognised from '../../../../components/ProviderRecognised';
import RemoveModal from '../../../../components/RemoveModal/index';
import ViewImage from '../../../../components/ViewImage';
import { MainContext } from '../../../../context/MainContext';
import { getFile } from '../../../../services/api/files';
import { getProjectTemplateById } from '../../../../services/api/projectTemplates';
import * as PreProcessedDocumentsActions from '../../../../services/redux/preProcessedDocuments/actions';
import { COLUMNS_HEADERS } from './columns';
import styles from './index.module.scss';

const { actionsWrapper } = styles;

const PreProcessedDoc = ({
  getPreProcessedDocumentsList,
  deletePreProcessedDocument,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { setLoading, setError } = useContext(MainContext);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [fileName, setFileName] = useState('');
  const [template, setTemplate] = useState({});
  const [model, setModel] = useState('');
  const [selectedImg, setSelectedImg] = useState(null);
  const [preprocessedDocumentId, setPreprocessedDocumentId] = useState(null);
  const onClickDeleteButton = () => {
    setShowRemoveModal(true);
  };

  const onClickViewIcon = (preProcessedDocument) => {
    setLoading(true);

    getFile(preProcessedDocument.fileName, preProcessedDocument.model)
      .then((value) => {
        setSelectedImg(URL.createObjectURL(value.data));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        setError({
          status: error.response ? error.response.status : 502,
          errorType: 'LOAD_FILE_ERROR',
        });
      });
  };

  const onClickDeleteIcon = (preProcessedDocument) => {
    setSelectedRows([preProcessedDocument]);
    setShowRemoveModal(true);
  };

  const onClickEditIcon = (preProcessedDocument) => {
    setPreprocessedDocumentId(preProcessedDocument.id);
    setModel(preProcessedDocument.model);

    if (preProcessedDocument.template !== null) {
      getProjectTemplateById({ id: preProcessedDocument.template })
        .then((data) => {
          setTemplate(data.data);
          setFileName(preProcessedDocument.fileName);
        })
        .catch((error) => {
          setError({
            status: error.response ? error.response.status : 502,
            errorType: 'UPDATE_PRE_PROCESSED_DOCUMENTS_ERROR',
          });
        });
    } else setFileName(preProcessedDocument.fileName);
  };

  const handleOnBulkDeleting = () => {
    setShowRemoveModal(false);

    selectedRows.forEach((row) => {
      deletePreProcessedDocument(row.id);
    });
    setSelectedRows([]);
  };

  const onCancelViewImg = () => setSelectedImg(null);

  const onBack = () => {
    setFileName('');
    setTemplate({});
  };

  if (fileName !== '') {
    return (
      <ProviderRecognised
        fileName={fileName}
        template={template}
        onBack={onBack}
        model={model}
        preProcessedId={preprocessedDocumentId}
      />
    );
  }

  return (
    <>
      <ViewImage
        img={selectedImg}
        visible={selectedImg}
        onCancel={onCancelViewImg}
      />
      <div className={`row ${actionsWrapper}`}>
        <div className="col-sm-12">
          <AccionaButton
            id="deleteBtn"
            htmlType="submit"
            disabled={!selectedRows.length}
            onClick={onClickDeleteButton}
            msg={intl.formatMessage({ id: 'button.delete' })}
            classIcon="icon fas fa-trash-alt"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <AccionaTable
            columns={COLUMNS_HEADERS}
            getItems={getPreProcessedDocumentsList}
            entity="preProcessedDocuments"
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            actions={(ppDoc) => (
              <>
                <AccionaTableButton
                  onClick={() => onClickViewIcon(ppDoc)}
                  type="view"
                  toolTip={intl.formatMessage({
                    id: 'viewAction.preProcessedDocuments',
                  })}
                />
                <AccionaTableButton
                  onClick={() => onClickEditIcon(ppDoc)}
                  type="edit"
                  toolTip={intl.formatMessage({
                    id: 'editAction.preProcessedDocuments',
                  })}
                />
                <AccionaTableButton
                  onClick={() => onClickDeleteIcon(ppDoc)}
                  type="delete"
                  toolTip={intl.formatMessage({
                    id: 'deleteAction.preProcessedDocuments',
                  })}
                />
              </>
            )}
          />

          <AccionaButton
            msg={intl.formatMessage({ id: 'back' })}
            onClick={() => navigate(-1)}
            classIcon="icon fas fa-chevron-left"
            style={{
              float: 'right',
              marginTop: '20px',
              marginRight: '0px',
            }}
          />
        </div>
      </div>

      <RemoveModal
        entity="preProcessedDocuments"
        selectedRows={selectedRows}
        msg={intl.formatMessage({
          id:
            selectedRows.length > 1
              ? 'delete.preProcessedDocuments'
              : 'delete.preProcessedDocument',
        })}
        onOk={handleOnBulkDeleting}
        onCancel={() => setShowRemoveModal((prev) => !prev)}
        hidden={!showRemoveModal}
      />
    </>
  );
};
const mapStateToProps = ({ preProcessedDocuments }) => ({
  preProcessedDocuments: preProcessedDocuments.list,
  fetching: preProcessedDocuments.fetching,
});

const matchDispachToProps = {
  getPreProcessedDocumentsList:
    PreProcessedDocumentsActions.getPreProcessedDocuments,
  deletePreProcessedDocument:
    PreProcessedDocumentsActions.deletePreProcessedDocument,
};

PreProcessedDoc.defaultProps = {
  selectedRows: [],
};

PreProcessedDoc.propTypes = {
  getPreProcessedDocumentsList: PropTypes.func.isRequired,
  deletePreProcessedDocument: PropTypes.func.isRequired,
  selectedRows: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps, matchDispachToProps)(PreProcessedDoc);
